import plugin from 'tailwindcss/plugin';

const masonry = plugin.withOptions(function () {
	return function ({ addComponents, e, theme }) {
		addComponents({
			[`.${e('masonry-gap')}`]: {
				borderRadius: `var(--masonry-image-border-radius, ${theme('spacing.0')})`,
				gap: `var(--masonry-gap, ${theme('spacing.1')})`,
				overflow: 'hidden',
			},
		});
	};
});

export default masonry;
